import {Dropdown} from 'react-bootstrap'

const ExportExcelDropdown = ({tableRef}: {tableRef: any}) => {
  return (
    <Dropdown>
      <Dropdown.Toggle variant='outline-primary' id='dropdown-basic'>
        Export Data
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => tableRef.current?.handleExport('current-page')}>
          This page only
        </Dropdown.Item>
        <Dropdown.Item onClick={() => tableRef.current?.handleExport('all')}>
          All pages
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ExportExcelDropdown
